import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { ConfirmPasswordView } from "@faire/retailer-visitor-shared/components/AppSignIn/components/ConfirmPasswordView";
import { CreatePasswordView } from "@faire/retailer-visitor-shared/components/AppSignIn/components/CreatePasswordView";
import { EmailSentWaitingView, MFAOptionsEmailSentWaitingView } from "@faire/retailer-visitor-shared/components/AppSignIn/components/EmailSentWaitingView";
import { EnterCodeView } from "@faire/retailer-visitor-shared/components/AppSignIn/components/EnterCodeView";
import { EnterEmailView } from "@faire/retailer-visitor-shared/components/AppSignIn/components/EnterEmailView";
import { EnterMFACodeView } from "@faire/retailer-visitor-shared/components/AppSignIn/components/EnterMFACodeView";
import { EnterMFAView } from "@faire/retailer-visitor-shared/components/AppSignIn/components/EnterMFAView";
import { EnterPasswordView } from "@faire/retailer-visitor-shared/components/AppSignIn/components/EnterPasswordView";
import { LoadingView } from "@faire/retailer-visitor-shared/components/AppSignIn/components/LoadingView";
import { ResetPasswordView } from "@faire/retailer-visitor-shared/components/AppSignIn/components/ResetPasswordView";
import { SelectMFAOptionView } from "@faire/retailer-visitor-shared/components/AppSignIn/components/SelectMFAOptionView";
import { SSOView } from "@faire/retailer-visitor-shared/components/AppSignIn/components/SSOView";
import { View } from "@faire/retailer-visitor-shared/components/AppSignIn/components/View";
import { useSignInEventTracker } from "@faire/retailer-visitor-shared/components/AppSignIn/useSignInEventTracker";
import { useHCaptchaLogin } from "@faire/retailer-visitor-shared/hooks/hCaptcha/useHCaptchaLogin";
import { getPayloadForConfirmPassword } from "@faire/retailer-visitor-shared/lib/ssoUtils";
import { PageLoadEvent } from "@faire/retailer-visitor-shared/services/performance/const";
import { PerformanceMarker } from "@faire/retailer-visitor-shared/services/performance/PerformanceMarker";
import { useSSOMFAStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/useSSOMFAStore";
import { useSSOPasswordStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/useSSOPasswordStore";
import { useSSOStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/useSSOStore";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { logAssert } from "@faire/web--source/common/logging";
import { trackEvent } from "@faire/web--source/common/trackEvent";
import { isNotUndefined, isNullish } from "@faire/web--source/common/typescriptUtils";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import pickBy from "lodash/pickBy";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
export var SignInController = function(props) {
    var onLogin = props.onLogin, sendResetEmail = props.sendResetEmail, signInTitle = props.signInTitle, hideApple = props.hideApple, isResetPasswordSuccess = props.isResetPasswordSuccess;
    // email can't be destructured due to const name conflicts
    var location = useLocation();
    var history = useHistory();
    var strictLocalize = useStrictLocalization().strictLocalize;
    var signInTitleEmailView = strictLocalize({
        id: "3aJgDA",
        defaultMessage: [
            {
                type: 0,
                value: "Sign in to Faire"
            }
        ]
    });
    var signInTitlePasswordView = strictLocalize({
        id: "CAZpRL",
        defaultMessage: [
            {
                type: 0,
                value: "Welcome back"
            }
        ]
    });
    var _props_email;
    var _useState = _sliced_to_array(useState({
        view: View.ENTER_EMAIL,
        email: (_props_email = props.email) !== null && _props_email !== void 0 ? _props_email : "",
        password: "",
        loggedInUser: null,
        profileImage: IImage.build()
    }), 2), state = _useState[0], setStateBase = _useState[1];
    useHCaptchaLogin();
    // Partially set state
    var setState = function(newState) {
        // Prefer original state value if new value is undefined or null
        var filteredState = pickBy(newState, function(val) {
            return !isNullish(val);
        });
        setStateBase(function(prevState) {
            return _object_spread({}, prevState, filteredState);
        });
    };
    var onComplete = function(result) {
        var searchParams = new URLSearchParams(location.search);
        if (searchParams.has("error")) {
            searchParams.delete("error");
        }
        var newQueryString = searchParams.toString();
        var newUrl = newQueryString ? "".concat(location.pathname, "?").concat(newQueryString) : location.pathname;
        history.replace(newUrl);
        return setState(_object_spread({}, pickBy({
            view: result.nextView,
            loggedInUser: result.user
        }, function(val) {
            return !isNullish(val);
        }), result));
    };
    var _useSSOStore = useSSOStore(), promptSSO = _useSSOStore.promptSSO, signUpSuggestions = _useSSOStore.signUpSuggestions;
    var _useSSOMFAStore = useSSOMFAStore(), showSelectMFA = _useSSOMFAStore.showSelectMFA, ssoMfaOptions = _useSSOMFAStore.mfaOptions, ssoMfaTitle = _useSSOMFAStore.mfaTitle, ssoMfaDescription = _useSSOMFAStore.mfaDescription, resetMFADescription = _useSSOMFAStore.resetMFADescription, resetMFATitle = _useSSOMFAStore.resetMFATitle, resetMFAOptions = _useSSOMFAStore.resetMFAOptions;
    var _useSSOPasswordStore = useSSOPasswordStore(), showConfirmPasswordView = _useSSOPasswordStore.showConfirmPasswordView, userHasPassword = _useSSOPasswordStore.userHasPassword;
    // mfaDescription, mfaTitle and mfaOptions cannot be destructured from ssoStore because they are also state variables
    var trackView = useSignInEventTracker(state.view).trackView;
    useEffect(function() {
        trackEvent("/login-modal");
        PerformanceMarker.get().mark(PageLoadEvent.firstMeaningfulPaint);
        trackView();
    }, [
        trackView
    ]);
    // The following are triggered when sign in via SSO in the AppSignUp
    // needs an additonal step that utilises a view in SignInController
    useEffect(function() {
        if (promptSSO) {
            if (userHasPassword) {
                setState({
                    view: View.SSO
                });
            } else {
                setState({
                    view: View.ENTER_PASSWORD
                });
            }
        }
    }, [
        promptSSO,
        userHasPassword
    ]);
    useEffect(function() {
        if (showSelectMFA) {
            setState({
                view: View.SELECT_MFA_OPTION,
                mfaOptions: ssoMfaOptions
            });
        }
    }, [
        showSelectMFA,
        ssoMfaOptions
    ]);
    useEffect(function() {
        if (ssoMfaDescription) {
            setState({
                view: View.ENTER_MFA,
                mfaDescription: ssoMfaDescription,
                mfaTitle: ssoMfaTitle
            });
        }
    }, [
        ssoMfaDescription,
        ssoMfaTitle
    ]);
    useEffect(function() {
        if (showConfirmPasswordView) {
            var _getPayloadForConfirmPassword = getPayloadForConfirmPassword(signUpSuggestions), email = _getPayloadForConfirmPassword.email, userName = _getPayloadForConfirmPassword.userName, profileImage = _getPayloadForConfirmPassword.profileImage;
            setState({
                view: View.CONFIRM_PASSWORD,
                email: email,
                userName: userName,
                profileImage: profileImage
            });
        }
    }, [
        showConfirmPasswordView,
        signUpSuggestions
    ]);
    var view = state.view, email = state.email, password = state.password, mfaDescription = state.mfaDescription, mfaOptions = state.mfaOptions, mfaTitle = state.mfaTitle, mfaMethod = state.mfaMethod, userToken = state.userToken, loggedInUser = state.loggedInUser, profileImage = state.profileImage, userName = state.userName, isMFAFromEmail = state.isMFAFromEmail, emailSentScenario = state.emailSentScenario;
    switch(view){
        case View.ENTER_EMAIL:
            return /*#__PURE__*/ _jsx(EnterEmailView, {
                defaultEmail: email,
                onComplete: onComplete,
                onLogin: onLogin,
                signInTitle: signInTitle !== null && signInTitle !== void 0 ? signInTitle : signInTitleEmailView,
                hideApple: hideApple,
                isResetPasswordSuccess: isResetPasswordSuccess
            });
        case View.ENTER_PASSWORD:
            return /*#__PURE__*/ _jsx(EnterPasswordView, {
                signInTitle: signInTitle !== null && signInTitle !== void 0 ? signInTitle : signInTitlePasswordView,
                defaultEmail: email,
                userToken: userToken,
                withEmail: isNotUndefined(email),
                sendResetEmail: sendResetEmail,
                onComplete: onComplete,
                onLogin: onLogin
            });
        case View.ENTER_CODE:
            return /*#__PURE__*/ _jsx(EnterCodeView, {
                email: email,
                userToken: userToken,
                onComplete: onComplete,
                onLogin: onLogin
            });
        case View.ENTER_MFA_CODE:
            return /*#__PURE__*/ _jsx(EnterMFACodeView, {
                email: email,
                userToken: userToken,
                onComplete: onComplete,
                onLogin: onLogin,
                mfaMethod: mfaMethod,
                mfaTitle: mfaTitle,
                password: password,
                mfaDescription: mfaDescription
            });
        case View.ENTER_MFA:
            return /*#__PURE__*/ _jsx(EnterMFAView, {
                email: email,
                password: password,
                userToken: userToken,
                mfaDescription: mfaDescription,
                mfaTitle: mfaTitle,
                mfaMethod: mfaMethod,
                onComplete: function(result) {
                    onComplete(result);
                    resetMFADescription();
                    resetMFATitle();
                },
                onLogin: onLogin,
                isMFAFromEmail: isMFAFromEmail
            });
        case View.CREATE_PASSWORD:
            logAssert(!!loggedInUser, "User should never be null when trying to create a password during sign in flow");
            return /*#__PURE__*/ _jsx(CreatePasswordView, {
                loggedInUser: loggedInUser,
                onComplete: onComplete,
                onLogin: onLogin
            });
        case View.RESET_PASSWORD:
            logAssert(!!userToken || !!email, "User token or email should be defined when trying to reset a password during sign in flow");
            return /*#__PURE__*/ _jsx(ResetPasswordView, {
                userToken: userToken,
                emailAddress: email
            });
        case View.SSO:
            return /*#__PURE__*/ _jsx(SSOView, {
                email: email,
                userToken: userToken,
                onComplete: onComplete,
                onLogin: onLogin
            });
        case View.CONFIRM_PASSWORD:
            return /*#__PURE__*/ _jsx(ConfirmPasswordView, {
                email: email,
                profileImage: profileImage,
                userName: userName,
                onComplete: onComplete,
                onLogin: onLogin
            });
        case View.SELECT_MFA_OPTION:
            return /*#__PURE__*/ _jsx(SelectMFAOptionView, {
                email: email,
                userToken: userToken,
                password: password,
                mfaOptions: mfaOptions !== null && mfaOptions !== void 0 ? mfaOptions : [],
                onComplete: function(result) {
                    onComplete(result);
                    resetMFAOptions();
                },
                onLogin: onLogin,
                isMFAFromEmail: isMFAFromEmail,
                mfaTitle: mfaTitle,
                mfaDescription: mfaDescription
            });
        case View.LOADING:
            return /*#__PURE__*/ _jsx(LoadingView, {});
        case View.MAGIC_LINK_SENT:
            return /*#__PURE__*/ _jsx(EmailSentWaitingView, {
                scenario: emailSentScenario,
                onComplete: onComplete,
                email: email
            });
        case View.MFA_OPTIONS_EMAIL_SENT:
            return /*#__PURE__*/ _jsx(MFAOptionsEmailSentWaitingView, {
                onComplete: onComplete,
                email: email,
                mfaTitle: mfaTitle,
                mfaDescription: mfaDescription,
                password: password
            });
        default:
            return null;
    }
};
